<section class="hero-section" #heroSection>
  <div class="hero-background">
    <div class="floating-dancers">
      <div class="dancer dancer-1"></div>
      <div class="dancer dancer-2"></div>
      <div class="dancer dancer-3"></div>
      <div class="dancer dancer-4"></div>
    </div>
    <div class="music-notes">
      <span class="note note-1">♪</span>
      <span class="note note-2">♫</span>
      <span class="note note-3">♬</span>
      <span class="note note-4">♩</span>
    </div>
  </div>

  <div class="hero-content">
    <div class="hero-text">
      <p class="hero-subtitle" #heroSubtitle>
        Explore classes, workshops, and events tailored for dancers of every style and skill level.
      </p>
      <div class="hero-slogan" #heroSlogan>
        <span class="slogan-text">For Dancers, By Dancers</span>
      </div>
    </div>

    <div class="hero-search" #heroSearch>
      <div class="search-container">
        <div class="search-input-group">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input
            type="text"
            [(ngModel)]="searchQuery"
            placeholder="Search for classes, studios, or events"
          >
        </div>
        <div class="location-input-group">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <input
            type="text"
            [(ngModel)]="locationCity"
            placeholder="City"
            class="city-input"
          >
          <select [(ngModel)]="locationState" class="state-select" title="Select state">
            <option value="">State</option>
            @for (s of states; track s) {
              <option [value]="s">{{ s }}</option>
            }
          </select>
          <button
            type="button"
            class="detect-btn"
            (click)="detectLocation()"
            [disabled]="isDetecting"
            title="Use my location"
          >
            @if (!isDetecting) {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path>
                <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path>
              </svg>
            } @else {
              <span class="detecting-spinner"></span>
            }
          </button>
        </div>
        @if (locationError) {
          <div class="location-error">{{ locationError }}</div>
        }
        <button type="button" class="search-btn" (click)="onSearch()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          Search
        </button>
      </div>
    </div>
  </div>
</section>
